const { flash } = require("modernizr");
import autosize from 'autosize';

document.addEventListener('DOMContentLoaded', function () {

    // Define loading functions
    const wlLoader = document.querySelector('.wl-loader');
    function showWlLoader(){
        wlLoader.classList.remove('wl-fallback');
        wlLoader.style.display="block";
        requestAnimationFrame(function () {wlLoader.classList.add('show-load') });
    }
    function hideWlLoader(){
        wlLoader.classList.remove('show-load');
        setTimeout(function(){
            wlLoader.classList.remove('wl-fallback');
            wlLoader.style.display="none";
        }, 200);
    }


    // Copy to clipboard (for share button)
    function copyToClipboard(el) {
        const textToCopy = el.value;

        navigator.clipboard.writeText(textToCopy).then(function () {
            el.classList.add('copied');
            setTimeout(() => {
                el.classList.remove('copied');
            }, 1000);
        }).catch(function (err) {
            // Unable to copy
            console.error('Could not copy text: ', err);
        });
    }

    let activeWishlist = null;

    // Show wishlist dropdowns
    function showWishlistList(wishlistWrapper) {
        wishlistWrapper.classList.add('active');
        activeWishlist = wishlistWrapper;
    }

    // Hide wishlist dropdowns
    function hideWishlistList() {
       const menu = document.querySelector('.wl-selector.active');
       if(menu){
        menu.classList.remove('active');
       }
    }

    // Event listener for the Escape key
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            hideWishlistList();
            closeModal();
        }
    });
	
	// Event listener for the Enter key
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
			if(event.target.classList.contains('modal-initiator')){
				event.preventDefault();
				initiateModal(event.target)
				return
			}
			var modalElements = document.querySelectorAll('.wl-generic-modal'),
				openModal = '';
			modalElements.forEach(element => {
				if(element.style.display ==='flex'){
					openModal = element;
				}
			});
			if(openModal && !event.target.classList.contains('.wl-generic-modal__close')){
				var savebtn = openModal.querySelector('.wl-generic-modal__save');
				if(savebtn){
					savebtn.click();
				}
			}
        }
    });

    // Set up modal vars
    function getModalElements() {
        return {
            modalParent: document.querySelector('.wl-generic-modal'),
            modalHeadContainer: document.querySelector('.wl-generic-modal__head'),
            modalScrollContainer: document.querySelector('.wl-generic-modal__scroll'),
            modalFootContainer: document.querySelector('.wl-generic-modal__actions')
        };
    }

	// Initiate modal 
	function initiateModal(target){
		var sendToModal = target.querySelector('.send-to-modal'),
			sendToModalHead = target.querySelector('.send-to-modal-head'),
			sendToModalCta = target.querySelector('.send-to-modal-cta'),
			elements = getModalElements();

		hideWishlistList();
		if (sendToModalHead) {
			elements.modalHeadContainer.innerHTML = sendToModalHead.innerHTML;
		} else {
			elements.modalScrollContainer.innerHTML = '';
		}
		if (sendToModal) {
			elements.modalScrollContainer.innerHTML = sendToModal.innerHTML;
			if(sendToModalCta){	
				elements.modalFootContainer.innerHTML = sendToModalCta.innerHTML;
			} else {
				elements.modalFootContainer.innerHTML = '<button class="wl-generic-modal__close">Cancel</button>';
			}
			elements.modalParent.style.display = "flex";
			document.body.classList.add('noscroll');
			trapFocusWithin('wl-generic-modal');
		}
	}

    // Attach events to document so RPC doesn't kill bindings
    document.addEventListener('click', function (event) {
        var target = event.target,
            closers = ['wl-generic-modal__close', 'wl-generic-modal__save','remove-btn','move-item','wl-generic-modal']; // items that should close modal without preventdefault

		if (Array.from(target.classList).some(className => className.includes('mobile-sort'))) {
			openMobileSortFlyout(target);
		}

		// close mobile sort flyouts when clicking outside of them	
		if (target.classList && !Array.from(event.target.classList).some(className => className.includes('mobile-sort'))) {
			closeMobileSortFlyout();
		}

		// If we're adding an idea
		if (target.classList.contains('wl-add-idea-button')) {
			let ideaInput = document.getElementById('newidea');
			setTimeout(function(){

				ideaInput.value = '';
			}, 500);
		}

        // If we're popping the modal
        else if (target.classList.contains('modal-initiator')) {
			initiateModal(target);
			return

        // If we're using a header select menu
        } else if(target.classList.contains('wl-selector__target')){
            const wishlistWrapper = target.closest('.wl-selector');
            if (wishlistWrapper.classList.contains('active')) { // if it's open, close it.
                hideWishlistList();
            } else if(!wishlistWrapper.classList.contains('wishlist-picker__disable')) {
                // Close any open wishlists before opening the clicked one
                if (activeWishlist) {
                    hideWishlistList(activeWishlist);
                }
                showWishlistList(wishlistWrapper);
            }
            event.stopPropagation();

        // Copy clicked item into select menu
        } else if(target.classList.contains('wl-selector__item')){
            let wishlistPicker = document.querySelector('.wl-selector.active .wl-selector__target');
            if(wishlistPicker){wishlistPicker.innerHTML = target.innerHTML;}
            hideWishlistList();
            showWlLoader();
        } else if(target.classList.contains('wl-generic-modal__close')){
            event.preventDefault();
            closeModal();
        } else if (closers.some(className => target.classList.contains(className))) {
            closeModal();
        } else if (target.classList.contains('share-url')) {
            copyToClipboard(target);
		} else {
            hideWishlistList();
        }
    });

    function observeModal(){
        var elements = getModalElements();
        // Watch for modal being populated by RPC, and show it
        const observer = new MutationObserver((mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    var rpcModal = document.querySelector('.modal-rpc-container');
                    if (elements.modalHeadContainer && rpcModal) {
                        elements.modalHeadContainer.innerHTML = elements.modalFootContainer.innerHTML = '';
                    }
                    document.body.classList.add('noscroll');
                    elements.modalParent.style.display = 'flex';
                }
            }
        });
        const config = {
            childList: true,
            attributes: true,
            subtree: true
        };
        if (elements.modalParent) {
            observer.observe(elements.modalParent, config);
        }
    }
    observeModal();

    // modal close fn
    function closeModal() {
        var elements = getModalElements();
        elements.modalParent.style.display = "none";
        document.body.classList.remove('noscroll');
        removeTrapFocusWithin();
    }

    // add focus trapping event listeners to modal
    let eventListeners = [];

    function trapFocusWithin(className) {
        const element = document.querySelector('.' + className);
        const focusableElements = element.querySelectorAll(
                'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
            ),
            firstElement = focusableElements[0],
            lastElement = focusableElements[focusableElements.length - 1];
        lastElement.focus();
        const keydownListener = (event) => {
            if (event.key === 'Tab') {
                if (focusableElements.length === 0) {
                    event.preventDefault();
                    return;
                }


                if (event.shiftKey && document.activeElement === firstElement) {
                    lastElement.focus();
                    event.preventDefault();
                } else if (!event.shiftKey && document.activeElement === lastElement) {
                    firstElement.focus();
                    event.preventDefault();
                }
            }
        };
        element.addEventListener('keydown', keydownListener);
        eventListeners.push({
            element,
            keydownListener
        });
    }

    // remove focus trapping event listeners to modal
    function removeTrapFocusWithin() {
        eventListeners.forEach(({
            element,
            keydownListener
        }) => {
            element.removeEventListener('keydown', keydownListener);
        });
        eventListeners = [];
    }

	function closeMobileSortFlyout(){
		const openFlyouts = document.querySelectorAll('.mobile-sort__active');
		openFlyouts.forEach(el => {
			el.classList.remove('mobile-sort__active');
		});
	}

	function scrollToSortedElement(el){
		el.scrollIntoView({
			block: "end",
			behavior: "smooth",
		});
	}

	function flashElement(el){
		setTimeout(function(){		
			el.classList.add('sw-item__flash');
			setTimeout(function(){
				el.classList.remove('sw-item__flash');
			}, 600);
		}, 400);
	}
	
	function openMobileSortFlyout(target) {
		const btnType = target.classList,
			elementToMove = target.closest('.sw-item'),
			sortMenu = target.closest('.mobile-sort');

		if(btnType.value === 'mobile-sort__toggler'){
			sortMenu.classList.toggle('mobile-sort__active');
		} else if(btnType.value === 'mobile-sort__first'){
			const parentElement = elementToMove.parentNode;
			parentElement.prepend(elementToMove);
			setTimeout(function(){
				closeMobileSortFlyout();
			}, 500);
			sendUpdatedSort();
			scrollToSortedElement(elementToMove);
			flashElement(elementToMove);
		} else if(btnType.value === 'mobile-sort__up'){
			const previousSibling = elementToMove.previousElementSibling;
			if (previousSibling) {
				previousSibling.parentNode.insertBefore(elementToMove, previousSibling);
				sendUpdatedSort();
				scrollToSortedElement(elementToMove);
				flashElement(elementToMove);
			}
		} else if(btnType.value === 'mobile-sort__down'){
			const nextSibling = elementToMove.nextElementSibling;
			if (nextSibling) {
				nextSibling.parentNode.insertBefore(elementToMove, nextSibling.nextSibling);
				sendUpdatedSort();
				scrollToSortedElement(elementToMove);
				flashElement(elementToMove);
			}
		} else if(btnType.value === 'mobile-sort__last'){
			const parentElement = elementToMove.parentNode;
			parentElement.appendChild(elementToMove);
			setTimeout(function(){
				closeMobileSortFlyout();
			}, 500);
			sendUpdatedSort();
			scrollToSortedElement(elementToMove);
			flashElement(elementToMove);
		}
	}


/**↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓**/
/**↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓**/
/** ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ Original, 2014 era Wishlist JS Below ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓**/
/**↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓**/
/**↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓**/




 if (!window.JSON || !window.JSON.stringify) {
	$.ajax({
		url: '/include/js/json3.min.js',
		dataType: 'script',
		cache: true
	});
}

/**
 * Initialize autosize textarea JS
 */
jQuery.fn.addAutoSize = function() {
	autosize(this);
};

/**
 * Updates the URL of the page
 *
 * @param {string} path The url that will be navigated to.
 * 						If the history API is supported, the query string is removed from the path.
 *
 * @result If history API, change the history object. Otherwise, window location change.
 */
if (history && history.replaceState) {
	jQuery.fn.changeLocation = function(path) {
		path = path.split('?');
		history.replaceState({ module:document.title }, document.title, path[0]);
		return this;
	};
} else {
	jQuery.fn.changeLocation = function(path) {
		window.location.href = path;
		return this;
	};
}

/**
 * Changes the document title.
 *
 * @param {string} title The new document title.
 */
jQuery.fn.changeTitle = function(title) {
	var pos = document.title.indexOf(' |');
	if (pos > -1) {
		title += document.title.substring(pos);
	}
	document.title = title;
	return this;
};

/**
 * Runs a custom function.
 * This is due to our function structure.
 * @param {string} myfunc The function name that we're trying to run.
 * @returns {*}
 */
jQuery.fn.createIdea = function(data) {
	return this.each(function() {
		if ($('.wl-add-idea-wrap').length == 0) {
			$(this).before(data);
		}
	});
};

/**
 * Runs a custom function.
 * This is due to our function structure.
 * @param {string} myfunc The function name that we're trying to run.
 * @returns {*}
 */
jQuery.fn.customFunc = function(myfunc) {
	return this.each(function() {
		if (myfunc === undefined) { return; }
		var fn_parts = myfunc.split('.'),
			fn = window,
			i;
		for (i in fn_parts) {
			fn = fn[fn_parts[i]];
			if (typeof fn == 'undefined') {
				fn = false;
				break;
			}
		}
		if (fn) {
			fn.apply(this, []);
		}
	});
};

/**
 * Focuses a field, placing the cursor at the end.
 * @returns {*}
 */
$.fn.focusToEnd = function() {
	return this.each(function() {
		var v = $(this).val();
		$(this).focus().val("").val(v);
	});
};

var $wl = {
	doc: null,
	popup: null,
	popup_target: null,
	grid: null,
	note_limit: 500,

	/**
	 * Grabs all eligible items and adds them to cart.
	 * @param {object} e The event object.
	 */
	addAllToCart: function(e) {
		e.preventDefault();
		var items = {}, items_length = 0, $this, itemid, val;
		$('div[data-itemid]', $wl.grid).each(function()
		{
			$this = $(this);
			itemid = $this.data('itemid');
			val = $('input[name="qty"]', $this).val();
			if (val == undefined)
			{
				val = $('.item-qty-text .amount', $this).text();
			}
			items[itemid] = val;
			if (itemid && val) {
				items_length++;
			}
		});
		if (items_length > 0) {
			window.location.href = '/store/cart.php?action=additem&itemids=' + JSON.stringify(items);
		}
	},

	/**
	 * Counts the number of characters entered into a field and updates the DOM (to comunicate limiting).
	 */
	charsCount: function() {
		var len = $wl.note_limit - this.value.length;
		$('.note-count', $(this).parent()).toggleClass('warn', (len < 11)).text(len);
	},

	/**
	 * Limits the number of characters entered into a field.
	 * @param {object} e The event object.
	 */
	charsLimit: function(e) {
		if (e.which < 0x20 || (e.shiftKey === true && e.keyCode != 13)) {
			return;
		}
		if (this.value.length == $wl.note_limit) {
			e.preventDefault();
		} else if (this.value.length > $wl.note_limit) {
			this.value = this.value.substring(0, $wl.note_limit);
		}
	},

	/**
	 * Handler for generic document clicks, such as closing popups.
	 * @param {object} e The event object.
	 */
	documentClick: function(e) {
	},

	/**
	 * Closes the idea form.
	 * @param {object} e The event object.
	 */
	ideaClose: function(e) {
		e.preventDefault();
		$(this).closest('.wl-add-idea-wrap').slideToggle('fast', function() { $(this).remove(); });
	},

	/**
	 * Intercepts specific keystrokes to prevent erroneous actions.
	 * @param {object} e The event object.
	 */
	interceptKeys: function(e) {
		switch (e.keyCode) {
			// Backspace key
			case 8:
//				e.preventDefault();
				break;
			// Escape key
			case 27:
				var $this = $(this),
					cancel = $this.closest('form').find('.btn.cancel');
				if (cancel.length > 0) {
					e.preventDefault();
					cancel.trigger('click');
				} else {
					$this.val('');
					if ($this.length > 0) {
						$this[0].blur();
					}
				}
				break;
		}
	},

	/**
	 * Closes an in-page message.
	 * @param {object} e The event object.
	 */
	msgClose: function(e) {
		e.preventDefault();
		$(this).closest('.sw-item-msg').slideToggle('fast', function() { $(this).remove(); });
	},

	/**
	 * Clears the timeout associated with hiding an in-page message.
	 */
	msgTimerClear: function() {
		clearInterval($(this).data('msg_timer'));
	},

	/**
	 * Initializes the timeout associated with hiding an in-page message.
	 */
	msgTimerSet: function() {
		var $this = $(this),
			data = $this.data(),
			udate = (new Date()).getTime(),
			timeout_len = 10 * 60 * 1000; /* 5 minutes */

		// If there is already a timer...
		if (data !== undefined && data.msg_timer_start !== undefined)
		{
			// Get the length remaining on the existing timer
			timeout_len = timeout_len - (udate - data.msg_timer_start);

			// Change the start time to the existing start time
			udate = data.msg_timer_start;

			// Clear the current timer if it exists
			clearInterval(data.msg_timer);
		}

		// Set the timer
		$this.data({
			msg_timer: setTimeout(
				$.proxy(function() {
					$(this).slideToggle('fast', function() { $(this).remove(); });
				}, this),
				timeout_len
			),
			msg_timer_start: udate
		});
	},

	/**
	 * Closes the popup.
	 * @param {object} e The event object.
	 */
	popupClose: function(e) {
		if (e !== undefined) {
			e.preventDefault();
		}
		$('.wlpop').removeClass('show');
	},

	/**
	 * Closes the popup after a specific interval
	 */
	popupCloseTimed: function() {
		$('.wlpop').data('hideTimer', setTimeout(function()
		{
			$wl.popupClose();
		}, 5 * 1000 /* 5 seconds */));
	},

	/**
	 * Removes a parameter from the querystring.
	 * @param {string} parameter The parameter that must be removed.
	 * @param {string} url The url we're removing the parameter from.
	 * @returns {string} The modified url.
	 */
	removeParameter: function(parameter, url)
	{
		var urlBase = '',
			queryString = '';

		if (url === undefined) {
			urlBase = window.location.pathname;
			queryString = window.location.search.replace('?', '');
		} else {
			var urlparts = url.split('?');
			if (urlparts.length >= 2)
			{
				urlBase = urlparts.shift(); //get first part, and remove from array
				queryString = urlparts.join("?"); //join it back up
			}
		}
		url = false;
		if (urlBase && queryString)
		{
			var prefix = encodeURIComponent(parameter) + '=',
				pars = queryString.split(/[&;]/g),
				i = pars.length;
			//reverse iteration as may be destructive
			for ( ; i-- > 0;) {
				//idiom for string.startsWith
				if (pars[i].lastIndexOf(prefix, 0) !== -1) {
					pars.splice(i, 1);
				}
			}
			pars = pars.join('&');
			url = urlBase + (pars ? '?' + pars : '');
		}
		return url;
	},

	/**
	 * Performs a wishlist callback.
	 * @param {string} url The callback url.
	 * @param {string} params The querystring.
	 */
	rpcPerform: function(url, params) {
		var $doc = $(document);
		if ($doc.data('wl-submitting') === true) { return; }
		clearInterval($doc.data('wl-process'));
		$doc.data({
			'wl-process': setTimeout(function() { showWlLoader(); }, 500),
			'wl-submitting': 1
		});
		var useAppHeaders = (window.app_id_token && window.app_access_token) ? true : false;
		var headers = {};
		if (useAppHeaders) {
			headers = {"App-Id-Token" : window.app_id_token, "App-Access-Token" : window.app_access_token };
		}

		$.ajax({
			type: "POST",
			url: url,
			data: params + '&RPC=',
			headers: headers,
			dataType: 'json',
			cache: false,
			timeout: 10000,
			tryCount: 0,
			retryLimit: 2,
			success: function(result)
			{
				clearInterval($doc.data('wl-process'));
				hideWlLoader();
				$doc.data('wl-submitting', 0);

				var action, scope, method, data, $scope;

				// Clear message timers
				$('form.sw-item-msg').each($wl.msgTimerClear);
				if (!result.hasOwnProperty('status') || result.status == 0 || !result.hasOwnProperty('actions')) {
					// $wl.popupClose();
					closeModal();
					return;
				}

				for (action in result.actions)
				{
					if (result.actions.hasOwnProperty(action))
					{
						scope = (result.actions[action][0] === null || result.actions[action][0] === undefined ? false : result.actions[action][0]);
						method = (result.actions[action][1] === null || result.actions[action][1] === undefined ? false : result.actions[action][1]);
						data = (result.actions[action][2] === null || result.actions[action][2] === undefined ? false : result.actions[action][2]);
						if (scope === false || method === false) { return; }
						$scope = $(scope);

						// Perform action
						if (data !== false) {
							$scope[ method ]( data );
						} else {
							$scope[ method ]();
						}
					}
				}

				// Add new message timers
				$('form.sw-item-msg').each($wl.msgTimerSet);
                observeModal();
                
			},
			error: function(jqXHR, textStatus, errorThrown)
			{
				$doc.data('wl-submitting', false);
				if (textStatus == 'timeout') {
					this.tryCount++;
					if (this.tryCount <= this.retryLimit) {
						$.ajax(this);
						return;
					}
					return;
				}
			}
		});

        
	},

	/**
	 * Prepares the data for a callback/
	 * @param {object} e The event object.
	 */
	rpcPrep: function(e) {
		e.preventDefault();
		var parts = $(this).prop('href').split('?');
		if (parts.length < 2) { return; }
		$wl.rpcPerform.apply(this, parts);
	},

	/**
	 * Gets the text selection position within an element.
	 * @link http://stackoverflow.com/a/8106733
	 * @returns {*}
	 */
	selectionGetPosition: function() {
		var selection = document.getSelection();
		return selection;
	},

	/**
	 * Sets the selection range
	 * @param input
	 * @param start
	 * @param end
	 */
	selectionSetCaretToPos: function(input, start, end) {
		$wl.selectionSetRange(input, start, end);
	},

	/**
	 * Set the text selection position and range within an element.
	 * @link http://stackoverflow.com/a/499158
	 * @param input
	 * @param selectionStart
	 * @param selectionEnd
	 */
	selectionSetRange: function(input, selectionStart, selectionEnd) {
		if (input.selectionSetRange) {
			input.focus();
			input.selectionSetRange(selectionStart, selectionEnd);
		}
		else if (input.createTextRange) {
			var range = input.createTextRange();
			range.collapse(true);
			range.moveEnd("character", selectionEnd);
			range.moveStart("character", selectionStart);
			range.select();
		}
	},

	/**
	 * Updates the single-item Add to Cart button URL in the same row when qty input changes.
	 */
	updateAddToCartUrl: function() {
		var $input = $(this),
			qty = Math.max(1, parseInt($input.val(), 10) || 1),
			$row = $input.closest('.sw-item'),
			$link = $row.find('a.wl-atc--single');
		if ($link.length && $link.data('itemid')) {
			var itemid = $link.data('itemid'),
				serial = $link.data('serial') || '';
			$link.attr('href', '/store/cart.php?action=additem&itemid=' + encodeURIComponent(itemid) + '&qty=' + encodeURIComponent(qty) + '&serial=' + encodeURIComponent(serial));
		}
	},

	/**
	 * Performs a price update once the qty change has been completed.
	 */
	spinEnd: function() {
		var $this = $(this);
		clearTimeout($this.data('qtyTimer'));
		$this.data('qtyTimer', setTimeout(function() {
			var qty = $this.val(),
				oldqty = $this.data('qty'),
				$form = $this.closest('form');
			if (qty == 0){
				$this.val("1");
				return;
			}
			if (qty === undefined || qty == '' || qty < 1 || qty == oldqty) { return; }
			$wl.rpcPerform($form.prop('action'), $form.serialize());
		}, 200));
	},

	/**
	 * Marks the beginning of the qty change.
	 * @param {object} e The event object.
	 */
	spinStart: function(e) {
		var $this = $(this),
			qty = $this.val();
		$this.data('qty', qty);
		clearTimeout($this.data('qtyTimer'));
	},

	/**
	 * Submits a form via callback.
	 * @param {object} e The event object.
	 */
	submitForm: function(e) {

		var $this = $(this),
			$target, fields, focus;
		if ($this.is('[no-rpc]')) { return; }
		e.preventDefault();
		$wl.rpcPerform($this.prop('action'), $this.serialize());

		// Remove field focus
		focus = $('input:focus, textarea:focus', $this);
		if (focus.length > 0) {
			focus[0].blur();
		}
		// Clear idea text
		if ($this.is('.wl-add-idea')) {
			$('input:not([type]), select, textarea', $this).val('');
		}
	},

	/**
	 * Toggles the menu between visible and hidden states.
	 * @param {object} e The event object.
	 */
	toggleMenu: function(e) {
		e.preventDefault();
		$('body').toggleClass('menu-show');
	},

	/**
	 * Caches the field value for change tracking.
	 * @param {object} e The event object
	 */
	valCache: function(e) {
		var $this = $(this);
		$this.data('val', $this.val());
	},

	/**
	 * Verifies that an error value has changed in some way.
	 * @param {object} e The event object
	 */
	valCheck: function(e) {
		var $this = $(this);
		if ($this.data('val') !== undefined && $this.val() != $this.data('val')) {
			var $err = $this.closest('.error').removeClass('error').find('.msg').remove();
			$this.removeAttr("aria-invalid");
			$this.removeAttr("aria-describedby");
			$this.removeData('val');
		}
	}
};

// Document interaction
$wl.doc = $(document)
	.on('click', $wl.documentClick)
	// Submissions
	.on( 'submit', '#wishlist form', $wl.submitForm )
	.on( 'click', 'a[data-rpc]', $wl.rpcPrep )
	.on( 'click', '.wl-subtotal-actions a', $wl.addAllToCart )
	.on( 'click', 'a.sw-idea-form-close', $wl.ideaClose)
	.on( 'click', 'a.sw-item-msg-close', $wl.msgClose )
	.on( 'focus', '.error input, .error textarea', $wl.valCache )
	.on( 'keyup', '.error input, .error textarea', $wl.valCheck )
	.on( 'keypress', 'input, textarea', $wl.interceptKeys )
	.on( 'keypress', 'textarea.item_note_field', $wl.charsLimit )
	.on( 'keyup', 'textarea.item_note_field', $wl.charsCount )
	.on( 'mousedown', 'input[name="qty"]', $wl.spinStart )
	.on( 'mouseup', 'input[name="qty"]', $wl.spinEnd )
	.on( 'input', 'input[name="qty"]', $wl.spinEnd )
	.on( 'input change', 'input[name="qty"]', $wl.updateAddToCartUrl )
	.on( 'focus', '#newidea', function() {
		$(this).closest('form').addClass('focus');
	})
	.on('blur', '#newidea', function() {
		$(this).closest('form').removeClass('focus');
	})
	.on( 'click', '.wl-menu', function(e) {
		var $target = $(e.target);
		if ($target.is('.wl-menu-inner') || $target.closest('.wl-menu-inner').length > 0) { return; }
		$wl.toggleMenu.apply(this, [e]);
	})
	.on( 'click', '.menu-tog', $wl.toggleMenu);

	function sendUpdatedSort(){
		var sortItems = document.querySelectorAll('.sw-item'),
				order = '';
			sortItems.forEach(el => {
				if(order === ''){
					order += 'item[]='+el.getAttribute('id').replace(/^item-/, '');
				} else {
					order += '&item[]='+el.getAttribute('id').replace(/^item-/, '');
				}
			});
			var useAppHeaders = (window.app_id_token && window.app_access_token) ? true : false;
			var headers = {};
			if (useAppHeaders) {
				headers = {"App-Id-Token" : window.app_id_token, "App-Access-Token" : window.app_access_token };
			}

			$.ajax({
				type: "POST",
				url: "/store/wishlist/",
				headers: headers,
				data: order + '&a=reorder&RPC=',
				cache: false
			});
	}

$(function() {
	$wl.popup = $('.wlpop');
	$wl.popup_target = $('.wlpop-target', $wl.popup);

	if (history && history.replaceState) {
		var new_url = $wl.removeParameter('a');
		if (new_url !== false) {
			history.replaceState({ module:document.title }, document.title, new_url);
		}
	}

	// Draggable
	$wl.grid = $('.sw-item-grid');

	$('body').sortable({
		axis: 'y',
		handle: ".sw-item__reorder",
		containment: 'parent',
		items: '.sw-item',
		scroll: true,
		tolerance: 'pointer',
		create: function(e, ui) {
			$('.sw-item__reorder').each(function(){
				this.title = "Drag and drop to sort";
			});
		},
		update: function(e, ui) {
			sendUpdatedSort();
		},
		start: function() {
			$('.sw-item-msg').animate({ height: 0, opacity: 0.5 }, 'fast', function()
			{
				$(this).remove();
			});
		}
	});

	// Autosize textareas
	$('.item-comment-col textarea').addAutoSize();
});
});
